import './index.scss';

// Libs
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter  } from 'react-router-dom';


// Providers
import DataProvider from './contexts/state';

import App from './App';

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter basename="/app/content/game/index.html" >
			<DataProvider>
				<App />
			</DataProvider>
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById('root')
);
